// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import { mqMedium } from '../../../js/lib/breakpoints';

export const GlobalSearch = (el) => {
  const ui = {
    el,
    body: select('body', document),
    input: select('.global-search__input', el),
    toggle: select('.global-search__toggle', el),
    form: select('.global-search__form', el),
    submitButton: select('.global-search__submit', el),
  };

  const desktopMq = window.matchMedia(mqMedium);

  const handleClickOutside = (event) => {
    try {
      if (ui.form.classList.contains('is-active') && !ui.el.contains(event.target)) {
        hideSearch();
      }
    } catch {
      return;
    }
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape' && ui.form?.classList.contains('is-active')) {
      event.preventDefault();
      hideSearch();
    }
  };

  const showSearch = () => {
    ui.input.focus();
    ui.toggle.setAttribute('aria-expanded', 'true');
    enableTabIndex();
  }

  const hideSearch = () => {
    ui.toggle.focus();
    ui.toggle.setAttribute('aria-expanded', 'false');
    ui.form.classList.remove('is-active');
    disableTabIndex();
  }

  const enableTabIndex = () => {
    // Make form elements focusable
    if (ui.input) ui.input.removeAttribute('tabindex');
    if (ui.submitButton) ui.submitButton.removeAttribute('tabindex');
  }

  const disableTabIndex = () => {
    // Remove form elements from tab order
    if (ui.input) ui.input.setAttribute('tabindex', '-1');
    if (ui.submitButton) ui.submitButton.setAttribute('tabindex', '-1');
  }

  // On phones the form sits open inside the menu (no toggle), so it stays in
  // the tab order; the closed menu itself is hidden from focus
  const syncTabIndex = () => {
    if (desktopMq.matches && !ui.form?.classList.contains('is-active')) {
      disableTabIndex();
    } else {
      enableTabIndex();
    }
  }

  const handleToggle = () => {
    ui.form.classList.toggle('is-active');

    if(ui.form.classList.contains('is-active')) {
      showSearch();
    } else {
      hideSearch();
    }
  };

  const addEvents = () => {
    if (ui.toggle) {
      ui.toggle.addEventListener('click', () => {
        handleToggle();
      });
    }

    document.addEventListener('click', (event) => {
      handleClickOutside(event);
    });

    document.addEventListener('keydown', handleKeydown);
    desktopMq.addEventListener('change', syncTabIndex);
  }

  const init = () => {
    syncTabIndex(); // Initialize in hidden state on desktop
    addEvents();
  };

  init();
};

export default GlobalSearch;
